import { Chip, ChipProps } from "@mui/material"
import { ResearchResult } from "interface/research"

type ResearchWordsChipsProps = {
	words: ResearchResult['words']
} & ChipProps
export const ResearchWordsChips = ({
	words,
	...others
}: ResearchWordsChipsProps) => {
	return words?.map((word, i) => (
		<Chip key={`word-${i}`} label={word} {...others}/>
	)) ?? <></>
}
